import { render, staticRenderFns } from "./MoveAboutUs.vue?vue&type=template&id=368e01d7&"
import script from "./MoveAboutUs.vue?vue&type=script&lang=js&"
export * from "./MoveAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./MoveAboutUs.vue?vue&type=style&index=0&id=368e01d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports